import { useMemo } from "react";
import { classNames, getGolfPlayerCategory } from "../../utils/appUtils";
import { UserView } from "../UserView";

interface DraftSelectShortlistedProps {
  player: any;
  index: number;
  onMembersSelected: (member: any, role: string) => void;
  disabled: boolean;
  availablePlayers: any[];
}

export const DraftSelectShortlisted: React.FC<DraftSelectShortlistedProps> = ({
  player,
  index,
  onMembersSelected,
  disabled,
  availablePlayers,
}) => {
  const isAvailable = useMemo(
    () => availablePlayers?.some((p) => p.playerId === player.playerId),
    [availablePlayers, player]
  );

  return (
    <div key={`player-container-${player.id}`}>
      <div
        className={classNames(
          "flex items-center justify-between p-1 rounded mb-2 gap-2",
          index % 2 === 0 ? "bg-gray-100 dark:bg-gray-700" : "",
          "hidden sm:flex"
        )}
      >
        <UserView member={player} strikeThrough={!isAvailable} />
        <div className="text-lg font-semibold text-gray-900 dark:text-gray-100">
          {!isAvailable && (
            <span className="px-2 py-1 text-xs font-medium bg-red-100 text-red-800 rounded-full">
              Not Available
            </span>
          )}
        </div>
        <div className="text-lg font-semibold text-gray-900 dark:text-gray-100">
          {getGolfPlayerCategory(player.ageCategory, player.gender)}
        </div>
        <div className="text-lg font-semibold text-gray-900 dark:text-gray-100">
          {player.playerHandicap}
        </div>
        <div className="flex items-center gap-2">
          <button
            className="px-3 py-1 bg-blue-500 text-white rounded disabled:opacity-20"
            onClick={() => onMembersSelected(player, "coreMember")}
            disabled={disabled || !isAvailable}
          >
            Select
          </button>
        </div>
      </div>

      <div
        className={classNames(
          "flex items-center justify-between p-1 rounded mb-2",
          index % 2 === 0 ? "bg-gray-100 dark:bg-gray-700" : "",
          "sm:hidden"
        )}
      >
        <div className="w-full">
          <UserView member={player} strikeThrough={!isAvailable} />
          <div className="flex flex-row justify-between gap-3">
            <div className="flex gap-3">
              <div className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                {getGolfPlayerCategory(player.ageCategory, player.gender)}
              </div>
              <div className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                {player.playerHandicap}
              </div>
            </div>
            <div className="flex items-center gap-2">
              {!isAvailable && (
                <span className="px-2 py-1 text-xs font-medium bg-red-100 text-red-800 rounded-full">
                  Not Available
                </span>
              )}
              <button
                className="px-3 py-1 bg-blue-500 text-white rounded disabled:opacity-20"
                onClick={() => onMembersSelected(player, "coreMember")}
                disabled={disabled || !isAvailable}
              >
                Pick
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
